import React from "react";
import {LiveCasinoVideoComponent} from "../../../../../components/live-casino-video/live-casino-video.component";
import {Check} from "@sparkware/app-utils";
import {SwiperListBaseModel} from "../swiper-list-base.model";
import {LiveStreamingListTitleBox} from "../../../../../components/live-streaming-tile/boxes/live-streaming-list-title/live-streaming-list-title.box";
import {LiveStreamingTitleIconBox} from "../../../../../components/live-streaming-tile/boxes/live-streaming-title-icon/live-streaming-title-icon.box";
import {LIVE_STREAMING_ITEM} from "../../../../../themes/css-global-classes";
import {ISwipeLogicHandler} from "../../swiper-logic-handler/swiper-logic-handler.interface";
import {LiveStreamSwipeLogicHandler} from "../../swiper-logic-handler/live-stream-swipe-logic-handler";
import {LiveStreamingNavigationPrevButtonBox, LiveStreamingNavigationNextButtonBox} from "../../../../../components/live-streaming-tile/boxes/live-streaming-navigation/live-streaming-navigation.box";

const LIVE_STREAM_GAMETYPES_OFFSET_STORAGE_KEY = "orbit-live-stream-gametypes-offset";

export class LiveCasinoVideoListModel extends SwiperListBaseModel {

    // HELPER for gametypes:
    // 2330093 is Adventures Beyond Wonderland
    // 2010163 is Crazy Time
    // 2330162 is Mega Fire Blaze Roulette
    // 2010013 is 888 Roulette
    // 2330030 is Age of Gods Roulette
    // 2010033 is Live Lighting Roulette
    // 2330017 is Quantum Roulette
    // 2010015 is Ruby Roulette
    private _baseGameTypesArray = [2330093, 2010163, 2330162, 2010013, 2330030, 2010033, 2330017, 2010015];

    protected _swipeLogicHandler: ISwipeLogicHandler = new LiveStreamSwipeLogicHandler(this.services, this);

    protected get _isAISorted(): boolean {
        return false;
    }

    private _isLiveStreamDisabled = () => {
        // live stream should be rendered on mobile only, excepting CIP8, if is enable from AB and
        // if user is authorized or if is not authorized only if is not disabled prelogin
        return !this.services.device.isMobile ||
            this.services.miniOrbit.isEnabled ||
            !this.services.abTestingFeatureDataProvider.isVideoLiveStreamEnabled ||
            this.services.httpLiveStream.isDisabledPrelogin
    }

    get maxGamesToShowInList(): number {
        return 8;
    }

    private _getGameTypesOffsetFromLocalStorage(): number {
        let storedValue = this.services.storage.getItem(LIVE_STREAM_GAMETYPES_OFFSET_STORAGE_KEY);

        return Check.isNullOrUndefined(storedValue) ? 0 : parseInt(storedValue);
    }

    private _gameTypesOffset: number = null;

    protected _getGameTypes(): number[] {

        if(!Check.isNullOrUndefined(this.services.httpLiveStream.isSupported)
            && !this.services.httpLiveStream.isSupported) {
            return [];
        }

        let baseArray = [...this._baseGameTypesArray];
        if(Check.isNullOrUndefined(this._gameTypesOffset)){
            this._gameTypesOffset = this._getGameTypesOffsetFromLocalStorage();
            let newOffset = (this._gameTypesOffset + 1) % (this._baseGameTypesArray.length);
            this.services.storage.setItem(LIVE_STREAM_GAMETYPES_OFFSET_STORAGE_KEY, newOffset);
        }

        let gameTypes = baseArray.splice(this._gameTypesOffset)
                        .concat(baseArray);

        if(this.services.liveTableFeeds.tablesData.length === 0) {
            return gameTypes;
        } else {
            return gameTypes.filter(gType => this.services.liveTableFeeds.openTablesIds.find(tableId => tableId === gType.toString()));
        }
    }

    protected _shouldBeDisplayed(): boolean {
        if(this._isLiveStreamDisabled()) {
            return false;
        }

        return super._shouldBeDisplayed() && this.gameTypes.length > 0;
    }

    _renderList(listPosition: number): React.ReactElement | null {
        return (<LiveCasinoVideoComponent key={this.listKey} viewModel={this} listPosition={listPosition}/>);
    }

    protected _renderHeaderIcon(): React.ReactElement | null {
        return (
            <LiveStreamingTitleIconBox>LIVE</LiveStreamingTitleIconBox>
        );
    }

    protected _renderHeaderText(): string | React.ReactElement {
        return (
            <LiveStreamingListTitleBox>
                {this.title.translation}
            </LiveStreamingListTitleBox>
        );
    }

    get numberOfGamesSkeletons(): number {
        return this._getNumberOfGamesSkeletons();
    }

    protected _getNumberOfGamesSkeletons(): number {
        if(Check.isNullOrUndefined(this.services.httpLiveStream.isSupported) || this.services.liveTableFeeds.tablesData.length === 0) {
            return 1;
        }

        return 0;
    }

    get templateType(): string {
        return LIVE_STREAMING_ITEM;
    }

    renderListNavigation(): React.ReactElement | null {

        const PrevIcon = this.services.theme.currentTheme.icons.leftArrowIcon;
        const NextIcon = this.services.theme.currentTheme.icons.rightArrowIcon;

        return (
            <React.Fragment>
                <LiveStreamingNavigationPrevButtonBox isActive={this.swipeLogicHandler.allowPrevious} onClick={() => this.swipeLogicHandler.movePrevious()}>
                    <PrevIcon size={3}/>
                </LiveStreamingNavigationPrevButtonBox>
                <LiveStreamingNavigationNextButtonBox isActive={this.swipeLogicHandler.allowNext} onClick={() => this.swipeLogicHandler.moveNext()}>
                    <NextIcon size={3}/>
                </LiveStreamingNavigationNextButtonBox>
            </React.Fragment>
        );
    }
}